export const I18n = {
	'en': {
		searchPlaceholder: 'Search by name',
		member: 'Member',
		contacts: 'Contacts'
	},
	'ru': {
		searchPlaceholder: 'Поиск по имени',
		member: 'Cотрудник',
		contacts: 'Контакты'
	},
	'sk': {
		searchPlaceholder: 'Vyhľadávanie podľa mena',
		member: 'člen',
		contacts: 'Kontakty'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/memberList/index.js